<template>
  <v-snackbar
    :value="hasConcent === null"
    :timeout="0"
    color="white"
    multi-line
    vertical
  >
    <span
      class="gdpr-text"
    >Informuojame, kad šioje svetainėje naudojami slapukai (ang. cookies).
      Paspaudę mygtuką „Sutinku“ patvirtinsite savo sutikimą. Bet kada galėsite
      atšaukti savo sutikimą pakeisdami interneto naršyklės nustatymus ir
      ištrindami įrašytus slapukus.</span>
    <v-row no-gutters>
      <v-btn
        color="primary"
        class="mr-2"
        @click="$emit('concent', true)"
      >
        Sutinku
      </v-btn>
      <v-btn
        v-if="canDisagree"
        color="grey"
        @click="$emit('concent', false)"
      >
        Nesutinku
      </v-btn>
    </v-row>
  </v-snackbar>
</template>

<script>
export default {
    name: 'GdprAgreement',
    props: {
        hasConcent: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            canDisagree: false
        }
    }
};
</script>

<style></style>
